export class FetchErrorServer {
  public readonly status: number
  public readonly statusText: string
  public readonly uuid: string
  public readonly path: string

  constructor(status: number, statusText: string, uuid: string, path: string) {
    this.status = status
    this.statusText = statusText
    this.uuid = uuid
    this.path = path
  }
}

export class FetchErrorUnauthorized {
  public readonly status: number
  public readonly statusText: string

  constructor(status: number, statusText: string) {
    this.status = status
    this.statusText = statusText
  }
}

export class FetchErrorMisc {
  public readonly status: number
  public readonly statusText: string

  constructor(status: number, statusText: string) {
    this.status = status
    this.statusText = statusText
  }
}
